import _omitBy from 'lodash/omitBy';
import { INITIAL_APPLICATION } from './constants';

/**
 * Applies an update to a base application ensuring that at a minimum the
 * initial application has been set.
 *
 * @param base
 * @param update
 * @returns {{summary, customerOptions, costsWeekly}}
 */
export default (base = {}, update = {}) => {
  return {
    ...INITIAL_APPLICATION,
    ...base,
    ...update,
    metaData: {
      ...INITIAL_APPLICATION.metaData,
      ...base.metaData,
      ...update.metaData,
      customerOptions: {
        ...INITIAL_APPLICATION.metaData.customerOptions,
        ...base.metaData.customerOptions,
        ..._omitBy(update.metaData.customerOptions, (value) => !value)
      },
      costsWeekly: {
        ...INITIAL_APPLICATION.metaData.costsWeekly,
        ...base.metaData.costsWeekly,
        ...update.metaData.costsWeekly
      }
    }
  };
};
